<template>
  <div style="height: calc( 100vh - 100px );">
    <div class="search-wrap" style="flex-direction: column">
      <div style="display: flex;flex-direction: row">
        <el-button size="mini" type="primary" @click="uploadExcel">上传模板</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length" type="primary" @click="meterImportExcelCache">导 入</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取 消</el-button>
<!--        <UploadFileSysc :host-url="host_url" :upload-url="host_url+'/admin/Meter/uploadFile'" v-model="excel_file">-->
<!--          <el-button size="mini" v-if="excel_file" type="primary" @click="showExcel">预览</el-button>-->
<!--          <el-button size="mini" v-if="excel_list&&excel_list.length" type="primary" @click="meterImportExcelCache">导入</el-button>-->
<!--          <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取消</el-button>-->
<!--        </UploadFileSysc>-->
      </div>
      <div style="display: flex;flex-direction: row;margin-top: 20px;">
        <div>
          总条数： <span style="color: #038dce">{{excel_list_num}}</span> 条
        </div>
        <div style="margin-left: 50px">
          插入条数： <span style="color: #ff3d00">{{excel_list_insert_num}}</span> 条
        </div>
        <div style="margin-left: 50px">
          修改条数： <span style="color: #ff3d00">{{excel_list_num-excel_list_insert_num}}</span> 条
        </div>
      </div>
    </div>
    <div class="table-wrap">
      <el-table v-if="excel_list&&excel_list.length" v-loading="loading" :data="excel_list">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <span :style="{color:(scope.row.id?'#038dce':'#2fb902')}">{{scope.row.id?'修改':'新增'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="异常信息警告" align="center" width="200">
          <template slot-scope="scope">
            <span style="color:#ff0000;">{{scope.row.msg}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="120"></el-table-column>
        <el-table-column prop="number" label="仪表编号" align="center" width="100"></el-table-column>
        <el-table-column prop="name" label="仪表名称" align="center" width="180"></el-table-column>
        <el-table-column prop="meter_nature_name" label="仪表性质" align="center" width="120"></el-table-column>
        <el-table-column prop="meter_energy_name" label="能耗类型" align="center" width="120"></el-table-column>
        <el-table-column prop="charging_standard_name" label="收费标准" align="center" width="180"></el-table-column>
        <el-table-column prop="house_name" label="所在房产" align="center" width="320"></el-table-column>
        <el-table-column prop="magnification" label="倍率" align="center" width="80"></el-table-column>
        <el-table-column prop="start_number" label="初始读数" align="center" width="120"></el-table-column>
        <el-table-column prop="parent_number" label="上级仪表编号" align="center" width="120"></el-table-column>
        <el-table-column prop="position" label="位置" align="center" width="100"></el-table-column>
        <el-table-column prop="install_time" label="安装日期" align="center" width="200"></el-table-column>
        <el-table-column prop="remarks" label="备注" align="center" width="100"></el-table-column>
        <el-table-column prop="id" label="主表编号" align="center" width="100"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import UploadFileSysc from "../components/UploadFileSysc";
import Http from "../../EnergyConsumption/common/Http";
export default {
  name: "ImportMeter",
  components:{UploadFileSysc},
  data(){
    return{
      loading:false,
      excel_file:"",
      excel_list:[]
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
  },
  methods:{
    showExcel(excel_file) {
      const that = this;
      that.loading=true;
      if(!excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      ERP.postRequest({
        url:"admin/Meter/meterImportExcelShow",
        data:{
          file:excel_file,
        }
      },res=>{
        if(res.code) {
          that.excel_file=excel_file;
          that.excel_list=res.data
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
        that.loading=false;
      })
    },
    importExcel() {
      const that = this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定导入Excel表单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        ERP.postRequest({
          url:"admin/Meter/meterImportExcel",
          data:{
            file:that.excel_file,
          }
        },res=>{
          if(res.code) {
            that.$message.success('Excel表单导入成功');
            that.excel_list=[];
            that.excel_file=""
          }else {
            that.$message.error('Excel表单导入失败');
          }
          that.loading=false;
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    meterImportExcelCache() {
      const that = this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定Excel表单数据完整性吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        ERP.postRequest({
          url:"admin/Meter/meterImportExcelCache",
          data:{
            batch_number:that.$route.query.batch_number||0,
            file:that.excel_file,
          }
        },res=>{
          if(res.code) {
            // that.$message.success('Excel表单导入成功');
            that.excel_list=[];
            that.excel_file="";
            that.$emit("meterImport",res.data)
          }else {
            that.$message.error('Excel表单导入待审缓存失败');
          }
          that.loading=false;
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    cleanImportExcel(){
      this.excel_file=""
      this.excel_list=[]
    },
    uploadExcel(){
      const that=this;
      Http.uploadFile(file=>{
        that.showExcel(file)
      })
    }
  },
  computed:{
    excel_list_num(){
      return this.excel_list.length
    },
    excel_list_insert_num(){
      return this.excel_list.filter(ret=>{
        return !!ret.id
      }).length
    },
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/components/ImportMeter.vue